
const CONSTANTS = {
  notVerifiedUser: "User has already signed up but not verified the phone number.",
  sessionInvalid: "Session is invalid.",
  packageSize: {
    1 : "Small, 0-2lbs",
    2 : "Medium, 2-5lbs",
    3 : "Large, 5-20lbs",
    4 : "Extra Large, 20-50lbs"
  },
  shipmentSection :{
     IM_SHIPPING : 1 ,
     IM_CARRYING : 2,
     IM_RECEIVING : 3
  },
  shipmentStatus: {
    1 : "draft",
    2 : "shipment creation complete - no offers",
    3 : "shipment creation complete - with offers",
    4 : "offer accepted",
    5 : "handoff done",
    6 : "on the way",
    7 : "carrier arrives at destination",
    8 : "carrier meets recipient",
    9 : "delivery completed"
  },
  SHIPMENT_STATUSARR: {
    DRAFT: 1,
    SHIPMENT_CREATION_COMPLETE_WITH_NO_OFFERS: 2,
    SHIPMENT_CREATION_COMPLETE_WITH_OFFERS: 3,
    OFFER_ACCEPTED: 4,
    HANDOFF_DONE: 5,
    ON_THE_WAY:6,
    CARRIER_ARRIVES_AT_DESTINATION:7,
    CARRIER_MEETS_RECIPIENT: 8,
    DELIVERY_COMPLETED: 9
  },
  carrierStatus: {
    0 : "no interaction",
    1 : "offer made",
    2 : "offer accepted"
  },
  carrierTransportType: {
    1 : "flight",
    2 : "car",
    3 : "public transport"
  },
  issue:[
    {
      value : '',
      label : "Select type of issue"
    },
    {
      value: 1 ,
      label:"Help with the app"
    },
    {
      value: 2 ,
      label:"Help with shipping"
    },
    {
      value: 3 ,
      label:"Help with carrying a shipment"
    },
    {
      value: 4 ,
      label:"I didn�t receive payment"
    },
    {
      value: 5 ,
      label:"Other issue"
    }
  ],
  SHIPMENT_TYPE: {
    POST_A_SHIPMENT: 1,
    REQUEST_AN_ITEM: 2
  },
  'IOS_URL': 'https://itunes.apple.com/us/app/airwaybill/id1198529029?ls=1&mt=8',
  'ANDROID_URL': 'http://play.google.com/store/apps/details?id=com.awb.android',
  'AMPLITUDE_EVENTS':{
    'FB_SIGN_SUCCESS':'FB_SIGN_SUCCESS',
    'EMAIL_SIGN_SUCCESS':'EMAIL_SIGN_SUCCESS',
    'PHONE_VERFICATION_START':'PHONE_VERFICATION_START',
    'PHONE_VERFICATION_COMPLETE':'PHONE_VERFICATION_COMPLETE',
    'USER_ADDED_PROMOCODE':'USER_ADDED_PROMOCODE',

    'REQ_ITEM_START': 'REQ_ITEM_START',
    'REQ_ITEM_DETAILS_START': 'REQ_ITEM_DETAILS_START',
    'REQ_ITEM_LOCATION': 'REQ_ITEM_LOCATION',
    'REQ_ITEM_DETAILS_NEXT': 'REQ_ITEM_DETAILS_NEXT',
    'REQ_ITEM_DELIVERY_START': 'REQ_ITEM_DELIVERY_START',
    'REQ_ITEM_DELIVERY_NEXT': 'REQ_ITEM_DELIVERY_NEXT',
    'REQ_ITEM_PAYMENT_START': 'REQ_ITEM_PAYMENT_START',
    'REQ_ITEM_PAYMENT_COMPLETE': 'REQ_ITEM_PAYMENT_COMPLETE',
    'REQ_ITEM_COMPLETE': 'REQ_ITEM_COMPLETE',
    'POST_ITEM_START': 'POST_ITEM_START',
    'POST_ITEM_PACKAGE_DETAILS_ADDED': 'POST_ITEM_PACKAGE_DETAILS_ADDED',
    'POST_ITEM_PICKUP_LOCATION_ADDED': 'POST_ITEM_PICKUP_LOCATION_ADDED',
    'POST_ITEM_DELIVERY_LOCATION_ADDED': 'POST_ITEM_DELIVERY_LOCATION_ADDED',
    'POST_ITEM_PAYMENT_ADDED': 'POST_ITEM_PAYMENT_ADDED',
    'POST_ITEM_COMPLETE': 'POST_ITEM_COMPLETE',
    'ITEM_REQ_MAKE_OFFER_START': 'ITEM_REQ_MAKE_OFFER_START',
    'ITEM_REQ_DELIVERY_MODE': 'ITEM_REQ_DELIVERY_MODE',
    'ITEM_REQ_MAKE_OFFER_COMPLETE': 'ITEM_REQ_MAKE_OFFER_COMPLETE',
    'ITEM_CARRY_MAKE_OFFER_START': 'ITEM_CARRY_MAKE_OFFER_START',
    'ITEM_CARRY_MAKE_OFFER_CARD_SELECTED': 'ITEM_CARRY_MAKE_OFFER_CARD_SELECTED',
    'ITEM_CARRY_MAKE_OFFER_CARD_ADDED': 'ITEM_CARRY_MAKE_OFFER_CARD_ADDED',
    'ITEM_CARRY_MAKE_OFFER_END': 'ITEM_CARRY_MAKE_OFFER_END',
    'REQ_ITEM_ACCEPT_OFFER': 'REQ_ITEM_ACCEPT_OFFER',
    'REQ_ITEM_PURCHASED': 'REQ_ITEM_PURCHASED',
    'REQ_ITEM_DELIVERY_COMPLETE': 'REQ_ITEM_DELIVERY_COMPLETE',
    'ITEM_CARRY_HANDOFF_COMPLETE': 'ITEM_CARRY_HANDOFF_COMPLETE',
    'ITEM_CARRY_DELIVERY_COMPLETE': 'ITEM_CARRY_DELIVERY_COMPLETE',
    'USER_INVITE_TRIGGERED' : 'USER_INVITE_TRIGGERED',
    'USER_SIGNUP_THROUGH_INVITE' : 'USER_SIGNUP_THROUGH_INVITE',
    'USER_ENABLE_SMS_NOTIFICATION' : 'USER_ENABLE_SMS_NOTIFICATION',
    'APP_OPEN_ON_NOTIFICATION_CLICK' : 'APP_OPEN_ON_NOTIFICATION_CLICK',
    'ITEM_CARRY_ACCEPT_OFFER' : 'ITEM_CARRY_ACCEPT_OFFER',
    'APP_OPEN': 'APP_OPEN',
    'NEW_TRIP_ADDED': 'NEW_TRIP_ADDED',
    'MYTRIP_UPDATED': 'MYTRIP_UPDATED',
    'MYTRIPS_MATCHING_SHIPMENT_FOUND': 'MYTRIPS_MATCHING_SHIPMENT_FOUND',
    'CARRIER_CANCEL_SHIPMENT' : 'CARRIER_CANCEL_SHIPMENT',
    'SHIPPER_CANCEL_SHIPMENT': 'SHIPPER_CANCEL_SHIPMENT',
    'DELETE_TRIP' : 'DELETE_TRIP'
  },
  packageSizeFilter: {
    1: 'Small',
    2: 'Medium',
    3: 'Large',
    4: 'Extra Large'
  },
  packageDetailsFilter: {
    1: 'Fits in a small backpack or carry-on bag.Less than 2 lbs.',
    2: 'Fits in a large duffel bag or carry-on suitcase. 2-5 lbs.',
    3: 'Fits in a large suitcase that requires check-in. 5-20 lbs.',
    4: 'Needs to be shipped in the cargo area.20 - 50 lbs. May incur extra fees.'
  },
  // 'STRIPE_KEY': "pk_test_FFFWuBoqOxD41GGDGgIyChlU",   //pk_live_nBiJTQ5fBfkiawZzfNrbtVwj  - sandbox key
  'STRIPE_KEY': "pk_live_nBiJTQ5fBfkiawZzfNrbtVwj",
  'LEAVE_FEEDBACK_TEXT_LIMIT': 300,
  'SEND_MESSAGE_TEXT_LIMIT':500,
   browseValidation :'Start date should not be greater than end date'
}

module.exports = CONSTANTS;



// WEBPACK FOOTER //
// app/common_constants.jsx